<template>
  <div class="sale-rep-index">

    <div class="rep-form">
      <div class="photo-wrap">
        <!-- <img class="photo-img" src="https://api.dujin.org/bing/1366.php"/> -->
      </div>
    </div>
    <div class="form-submit-button">
      <van-button round block type="primary" @click="repair">
        在线报修
      </van-button>

      <van-button round block type="primary" @click="search" class="search-btn">
        查看配置
      </van-button>
    </div>
    <div style="width: 100%; position: fixed;bottom: 19px;color: rgba(128, 128, 128, 1);font-size: 12px;line-height: 150%;text-align: center;">© StoneGroup All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      scanShow: false,
      formData: {
        sn_num: ''
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },

  methods: {
    init() {
      this.getBackground();
    },
    getBackground() {
      this.$post(this.$api.stDashboardBackground, {}).then((res) => {
        let url = res.data ? `url(${this.$api.domain}/${res.data})` : 'https://api.dujin.org/bing/1366.php';
        document.querySelector('body').style.setProperty('--dashboard-image', url);
      });
    },
    search() {
      this.$router.push('/saleRep/search');
    },
    repair() {
      this.$router.push('/saleRep/searchForRep');
      // this.$router.push('/saleRep/repairSn');
    }
  },
};
</script>

<style lang="scss" scoped>
.sale-rep-index::after {
  content: '';
  background-image: var(--dashboard-image);
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  background-size: cover;
}

.sale-rep-index {
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  margin: 0px;
  
  .form-submit-button {
    position: fixed;
    bottom: 88px;
    padding-left: 5%;
    padding-right: 5%;
    width: 90%;
    display:flex;
    justify-content: space-between;
    z-index: 1;
  }

  /deep/ .search-btn {
    background-color: #07c160 !important;
    border: 1px solid #07c160 !important;

  }

  .van-button--round {
    border-radius: 5px;
    background-color: #1989fa;
    border: none;
  }
  
  .van-button--block {
    width: 48%;
  }
}


</style>

